import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import HeroComex from "../components/HeroComex";
import BeneficiosComex from "../components/BeneficiosComex";
import MarcasConfian from "../components/MarcasConfian";
import InnovarAutomotriz from "../components/InnovarAutomotriz";
import HeroContacto from "../components/HeroContacto";
import TestimoniosComex from "../components/TestimoniosComex";
import VideoComex from "../components/VideoComex";
import Switcher from "../components/switcher";
import useStore from "../store/useStore";
import FormHosb from "../components/FormHubSpot";
import SkeletonLoader from "../components/SkeletonLoader";

export default function Ejemplo1() {
  const {
    heroComex,
    getHeroComexBox,
    beneficiosComex,
    getBeneficiosComex,
    automotrizComex,
    getAutomotrizComex,
    contactoComex,
    getContactoComex,
    marcasComex,
    getMarcasComex,

    getTestimonioComex,
    videoComex,
    getVideoComex,
  } = useStore();

  useEffect(() => {
    getHeroComexBox();
    getBeneficiosComex();
    getAutomotrizComex();
    getContactoComex();
    getMarcasComex();
    getTestimonioComex();
    getVideoComex();
  }, [
    getHeroComexBox,
    getBeneficiosComex,
    getAutomotrizComex,
    getContactoComex,
    getMarcasComex,
    getTestimonioComex,
    getVideoComex,
  ]);

  return (
    <>
      <Navbar />
      <div className="mx-auto bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-white">
        <div className="mt-[100px]">
          {heroComex?.length ? (
            heroComex.map((item, index) => (
              <HeroComex
                key={item.id || index}
                titulo={item.titulo}
                subtitulo={item.subtitulo}
                imagen={item.img?.formats?.thumbnail?.url || item.img?.url}
              />
            ))
          ) : (
            <HeroComex titulo="Cargando..." subtitulo="Espere un momento" />
          )}
        </div>

        <section className="my-[100px]">
          {videoComex?.[1] ? (
            <VideoComex
              key={videoComex[1].id}
              poster={videoComex[1].video?.[0]?.url}
              controls={videoComex[1].controls}
              autoPlay={videoComex[1].autoPlay}
              muted={videoComex[1].muted}
              loop={videoComex[1].loop}
            />
          ) : (
            <SkeletonLoader text="Cargando video..." />
          )}
        </section>

        <section className="my-[100px]">
          <h2 className="text-left container text-3xl md:text-4xl lg:text-5xl font-extrabold text-sidom-orange mb-8">
            Beneficios
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 container">
            {beneficiosComex?.length ? (
              beneficiosComex.map((item, index) => (
                <BeneficiosComex
                  key={item.id || index}
                  icon={item.icon?.formats?.thumbnail?.url || item.icon?.url}
                  titulo={item.titulo}
                  subtitulo={item.subtitulo}
                />
              ))
            ) : (
              <SkeletonLoader text="Cargando beneficios..." />
            )}
          </div>
        </section>

        <section className="my-[100px]">
          {videoComex?.[0] ? (
            <VideoComex
              key={videoComex[0].id}
              video={videoComex[0].video?.[0]?.url}
              controls={videoComex[0].controls}
              autoPlay={videoComex[0].autoPlay}
              muted={videoComex[0].muted}
              loop={videoComex[0].loop}
            />
          ) : (
            <SkeletonLoader text="Cargando video..." />
          )}
        </section>

        <section className="my-[100px]">
          {marcasComex?.length ? (
            marcasComex.map((item, index) => {
              const marcas = Array.isArray(item.img)
                ? item.img.map((marca) => ({
                    src: marca.formats?.thumbnail?.url
                      ? `https://api.institucional.global.sidom.io${marca.formats.thumbnail.url}`
                      : `https://api.institucional.global.sidom.io${marca.url}`,
                    alt: marca.alternativeText || item.titulo,
                  }))
                : item.img?.[0]
                ? [
                    {
                      src: item.img[0].formats?.thumbnail?.url
                        ? `https://api.institucional.global.sidom.io${item.img[0].formats.thumbnail.url}`
                        : `https://api.institucional.global.sidom.io${item.img[0].url}`,
                      alt: item.titulo,
                    },
                  ]
                : [];

              return (
                <MarcasConfian
                  key={item.id || index}
                  titulo={item.titulo}
                  marcas={marcas}
                />
              );
            })
          ) : (
            <SkeletonLoader text="Cargando marcas..." />
          )}
        </section>

        <section className="my-[100px]">
          <FormHosb />
        </section>

        <section className="my-[100px]">
          {automotrizComex?.length ? (
            automotrizComex.map((item, index) => (
              <InnovarAutomotriz
                key={item.id || index}
                titulo={item.titulo}
                parrafos1={item.Subtitlo1}
                parrafos2={item.Subtitulo2}
                parrafos3={item.Subtitulo3}
              />
            ))
          ) : (
            <SkeletonLoader text="Cargando innovaciones automotrices..." />
          )}
        </section>

        <section className="my-[100px]">
          {contactoComex?.length ? (
            contactoComex.map((item, index) => (
              <HeroContacto
                key={item.id || index}
                titulo={item.titulo}
                buttonText="Solicitar DEMO"
                svg={
                  item.svg?.[0]?.formats?.thumbnail?.url || item.svg?.[0]?.url
                }
                img={
                  item.img?.[0]?.formats?.thumbnail?.url || item.img?.[0]?.url
                }
              />
            ))
          ) : (
            <HeroContacto titulo="Cargando..." boton="Espere un momento" />
          )}
        </section>

        <section className="my-[100px]">
          <TestimoniosComex />
        </section>
      </div>

      <Switcher />
      <Footer />
    </>
  );
}
